import { memo } from 'react'

import MarkdownRender from 'LuxKit/MarkdownRender'

interface Props {
  description: string
}

function PropertyAdditionalDescription({ description }: Props) {
  return <MarkdownRender type="compact" fontSize="medium" content={description} />
}

export default memo(PropertyAdditionalDescription)
